import React from "react";
import {
    Grid,
    Skeleton,
    Box,
    Divider,
} from "@mui/material";

const CartSkeleton: React.FC = () => {
    return (
        <>
            {[1, 2, 3, 4, 5].map((item) => (
                <React.Fragment key={item}>
                    <Grid
                        container
                        direction="row"
                        spacing={1}
                        maxWidth={"md"}
                        alignContent="center"
                        alignItems="center"
                    >
                        {/* Image Skeleton */}
                        <Grid item xs={2}>
                            <Skeleton
                                variant="rectangular"
                                width={150}
                                height={150}
                                sx={{ borderRadius: 1 }}
                            />
                        </Grid>

                        {/* Title + Variants + Remove button */}
                        <Grid item xs={4}>
                            <Box sx={{ width: "100%", px: 1 }}>
                                <Skeleton width="80%" height={28} />
                                <Skeleton width="60%" height={20} sx={{ mt: 1 }} />
                                <Skeleton width="40%" height={20} sx={{ mt: 1 }} />
                                <Skeleton
                                    variant="rectangular"
                                    width={90}
                                    height={32}
                                    sx={{ mt: 2, borderRadius: 1 }}
                                />
                            </Box>
                        </Grid>

                        {/* Quantity Buttons */}
                        <Grid item xs={3}>
                            <Box display="flex" alignItems="center">
                                <Skeleton variant="circular" width={32} height={32} />
                                <Skeleton width={30} height={30} sx={{ mx: 2 }} />
                                <Skeleton variant="circular" width={32} height={32} />
                            </Box>
                        </Grid>

                        {/* Price */}
                        <Grid item xs={3}>
                            <Skeleton width={70} height={28} />
                        </Grid>
                    </Grid>

                    <Divider sx={{ marginTop: "1px", borderWidth: "1px" }} />
                </React.Fragment>
            ))}
        </>
    );
};

export default CartSkeleton;
